<template>
	<article class="product-rank">
		<ManagingSection :columnCount="2">
			<ManagingBox title="제품검색">
				<input
					ref="wordInput"
					v-model="word"
					type="text"
					@keyup.enter="enterSearchProduct"
					placeholder="검색어 + Enter"
				/>
			</ManagingBox>
			<ManagingBox title="제품선택">
				<select
					class="select"
					v-model="selectedProductId"
					@change="changeProductId"
				>
					<option
						v-for="item in productList"
						:key="item.id"
						:value="item.id"
						:disabled="item.id === null"
					>
						{{ item.title }}
					</option>
				</select>
			</ManagingBox>
			<ManagingBox title="항번검색" :isBlockBox="true">
				<InputText
					ref="idInput"
					@input="inputId"
					mode="number"
					:inputWidth="120"
					placeholder="제품항번"
				/>
				<button
					class="btn product-rank__id-search-btn"
					type="button"
					@click="searchById"
					v-text="'검색'"
				/>
			</ManagingBox>
		</ManagingSection>
		<ManagingSection :isTable="true">
			<table class="table-main">
				<thead>
					<tr>
						<th
							class="product-rank__product-name"
							:colspan="tableTitleList.length"
							v-text="productTitle"
						/>
					</tr>
					<tr>
						<th
							v-for="tableTitle in tableTitleList"
							:key="tableTitle"
							v-text="tableTitle"
						/>
					</tr>
				</thead>
				<tbody v-if="productTitle">
					<tr class="product-rank__table-bundle-tr">
						<td
							v-for="{
								excelButtonText,
								thList,
								key,
								list,
							} in bundle.list"
							class="product-rank__table-bundle-td"
						>
							<button
								v-if="excelButtonText"
								class="btn-excel product-rank__excel-btn"
								@click="excelDown(key)"
								v-text="excelButtonText"
							/>
							<div
								:class="
									excelButtonText
										? 'product-rank__list-wrapper'
										: 'product-rank__list-wrapper--no-button'
								"
							>
								<table>
									<thead>
										<tr>
											<th
												v-for="(th, idx) in thList"
												:key="idx"
												v-text="th"
											/>
										</tr>
									</thead>
									<tbody v-if="key === 'brandRankWeekly'">
										<tr
											v-for="(item, idx) in list"
											:key="idx"
										>
											<td v-text="item.rankType" />
											<td v-text="item.year" />
											<td v-text="item.month" />
											<td v-text="item.startDate" />
											<td v-text="item.endDate" />
											<td v-text="item.rank" />
										</tr>
									</tbody>
									<tbody v-else-if="key === 'brandRankDaily'">
										<tr
											v-for="(item, idx) in list"
											:key="idx"
										>
											<td v-text="item.rankType" />
											<td v-text="item.date" />
											<td v-text="item.rank" />
										</tr>
									</tbody>
									<tbody
										v-else-if="key === 'categoryRankWeekly'"
									>
										<tr
											v-for="(item, idx) in list"
											:key="idx"
										>
											<td v-text="item.date" />
											<td v-text="item.secondName" />
											<td v-text="item.secondRank" />
											<td v-text="item.thirdName" />
											<td v-text="item.thirdRank" />
											<td v-text="item.ratingAvg" />
										</tr>
									</tbody>
									<tbody
										v-else-if="
											key === 'popularRank' ||
											key === 'monthRank'
										"
									>
										<tr
											v-for="(item, idx) in list"
											:key="idx"
										>
											<td v-text="item.date" />
											<td v-text="item.rank" />
										</tr>
									</tbody>
								</table>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
	</article>
</template>
<script>
	import moment from 'moment';
	import _ from 'lodash';
	import util from '@/util.js';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import InputText from '@/components/InputText.vue';

	export default {
		name: 'ProductRank',
		components: { ManagingSection, ManagingBox, InputText },
		data() {
			return {
				word: '',
				selectedProductId: null,
				idProduct: '',
				productList: [{ title: '검색하세요', id: null }],
				productTitle: '',
				tableTitleList: [
					'브랜드 주간 랭킹',
					'브랜드 일 랭킹',
					'카테고리 주간 랭킹',
					'인기 신제품 일간 랭킹',
					'신제품 월별 일간 랭킹',
				],
				tableKeyList: [
					'brandRankWeekly',
					'brandRankDaily',
					'categoryRankWeekly',
					'popularRank',
					'monthRank',
				],
				thBundle: [
					['브랜드', '년', '월', '시작일', '종료일', '평균 랭킹'],
					['브랜드', '날짜', '랭킹'],
					[
						'날짜',
						'2차카테고리',
						'랭킹',
						'3차카테고리',
						'랭킹',
						'평점',
					],
					['날짜', '랭킹'],
					['날짜', '랭킹'],
				],
				brandRankWeekly: [],
				brandRankDaily: [],
				categoryRankWeekly: [],
				popularRank: [],
				monthRank: [],
				lastApiUrl: '',
			};
		},
		computed: {
			bundle() {
				return {
					list: this.tableKeyList.map((key, idx) => {
						return {
							thList: this.thBundle[idx],
							list: this[key],
							excelButtonText:
								key === 'brandRankDaily'
									? '브랜드 엑셀 다운로드'
									: key === 'categoryRankWeekly'
										? '카테고리 엑셀 다운로드'
										: null,
							key,
						};
					}),
				};
			},
		},
		mounted() {
			this.setFilter();
		},
		methods: {
			async setFilter() {
				const query = this.$route.query;
				const productTitle = query.productTitle;
				const idProduct = query.idProduct;
				const word = query.word;
				const selectedProductId = query.selectedProductId;
				if (productTitle && (idProduct === 0 || idProduct)) {
					this.$refs.idInput.value = idProduct.toString();
					this.productList = [
						{ title: productTitle, id: Number(idProduct) },
					];
					this.selectedProductId = Number(idProduct);
					await this.getRankData(Number(idProduct));
				} else if (
					word &&
					(selectedProductId === 0 || selectedProductId)
				) {
					this.word = word;
					await this.getProductList();
					this.selectedProductId = Number(selectedProductId);
					await this.getRankData(Number(selectedProductId));
				}
			},
			pushQuery(type) {
				const query = {};
				if (type === 'id') {
					query.productTitle = this.productList[0].title;
					query.idProduct = this.productList[0].id;
				} else if (type === 'select') {
					query.word = this.word;
					query.selectedProductId = this.selectedProductId;
				}
				this.$router.replace({ query }).catch(() => {
					window.location.reload();
				});
			},
			async getProductList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/analysis/reviews/products`,
						{ params: { word: this.word } }
					);
					if (!data.products.length) {
						this.productList = [{ title: '검색하세요', id: null }];
						return;
					}
					this.productList = data.products.reduce(
						(acc, curr) => {
							acc.push({
								title: `${curr.isDiscontinue ? '[단종]' : ''}[${curr.brandTitle}] ${curr.productTitle}`,
								id: curr.idProduct,
							});
							return acc;
						},
						[{ title: '제품을 선택하세요', id: null }]
					);
				} catch (err) {
					console.error(err);
					alert('랭킹목록을 불러오는데 실패했습니다.');
				}
			},
			enterSearchProduct: _.debounce(async function () {
				await this.getProductList();
				this.selectedProductId = null;
				this.idProduct = '';
				this.$refs.idInput.init();
			}, 500),
			inputId(idProduct) {
				this.idProduct = idProduct;
			},
			async getRankData(productId) {
				try {
					const { config, data } = await this.$axiosAdmin2.get(
						`/api/review/product/${productId}/rank`
					);
					this.lastApiUrl = config.url;
					if (!data.productTitle) {
						this.productTitle = '';
						this.brandRankWeekly = [];
						this.brandRankDaily = [];
						this.categoryRankWeekly = [];
						this.popularRank = [];
						this.monthRank = [];
						return false;
					}
					this.productTitle = data.productTitle;
					this.brandRankWeekly = data.brandRank.weekly;
					this.brandRankDaily = data.brandRank.daily;
					this.categoryRankWeekly = data.categoryRank.weekly;
					this.popularRank = data.popularRank.map(item => ({
						...item,
						date: moment(item.date, 'YYYYMMDD').format(
							'YYYY-MM-DD'
						),
					}));
					this.monthRank = data.monthRank.map(item => ({
						...item,
						date: moment(item.date, 'YYYYMMDD').format(
							'YYYY-MM-DD'
						),
					}));
					return true;
				} catch (err) {
					console.error(err);
					alert('성분목록을 불러오는데 실패했습니다.');
					return false;
				}
			},
			async searchById() {
				try {
					const hasFactorList = await this.getRankData(
						this.idProduct
					);
					if (!hasFactorList) return;
					this.word = '';
					this.$refs.wordInput.value = '';
					this.selectedProductId = this.idProduct;
					this.productList = [
						{ title: this.productTitle, id: this.idProduct },
					];
					this.pushQuery('id');
				} catch (err) {
					console.error(err);
					alert('성분목록을 불러오는데 실패했습니다.');
				}
			},
			async changeProductId() {
				await this.getRankData(this.selectedProductId);
				this.pushQuery('select');
			},
			brandRankDailyExcelDown() {
				const rowsList = [
					this.brandRankWeekly.map((item, idx) => [
						idx + 1,
						item.rankType,
						item.year,
						item.month,
						item.startDate,
						item.endDate,
						item.rank,
					]),
					this.brandRankDaily.map((item, idx) => [
						idx + 1,
						item.rankType,
						item.date,
						item.rank,
					]),
				];
				util.getCsv(
					rowsList,
					[
						`${this.productTitle}_브랜드_주간랭킹`,
						`${this.productTitle}_브랜드_일랭킹`,
					],
					[
						[
							'NO',
							'브랜드',
							'년',
							'월',
							'시작일',
							'종료일',
							'평균랭킹',
						],
						['NO', '브랜드', '날짜', '랭킹'],
					],
					`[브랜드]_${this.productTitle}_${Date.now()}`,
					this.lastApiUrl
				);
			},
			categoryRankWeeklyExcelDown() {
				const rows = this.categoryRankWeekly.map((item, idx) => [
					idx + 1,
					item.date,
					item.secondName,
					item.secondRank,
					item.thirdName,
					item.thirdRank,
					item.ratingAvg,
				]);
				util.getCsv(
					[rows],
					[`${this.productTitle}_카테고리_주간랭킹`],
					[
						[
							'NO',
							'날짜',
							'2차카테고리',
							'랭킹',
							'3차카테고리',
							'랭킹',
							'평점',
						],
					],
					`[카테고리]_${this.productTitle}_${Date.now()}`,
					this.lastApiUrl
				);
			},
			excelDown(key) {
				this[`${key}ExcelDown`]();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.product-rank {
		&__id-search-btn {
			display: inline-block;
			margin-top: 3px;
			margin-left: 3px;
		}

		&__product-name {
			background: #dfe6ee;
		}

		&__table-bundle-tr:hover {
			background-color: transparent;
		}

		&__table-bundle-td {
			vertical-align: top;
			text-align: right;
		}

		&__excel-btn {
			margin-bottom: 12px;
		}

		&__list-wrapper {
			overflow-y: auto;
			max-height: 700px;
			border: solid 1px #dfe6ee;
		}

		&__list-wrapper--no-button {
			@extend .product-rank__list-wrapper;

			margin-top: 42px;
		}
	}
</style>
